
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.less'
import 'lib-flexible/flexible'
import Util from './utils/util'
Vue.use(Util)

import Vant from 'vant'
import { Lazyload } from 'vant';
import 'vant/lib/index.css'
Vue.use(Vant);
Vue.use(Lazyload, {
  lazyComponent: true,
});


import store from './vuex/store'
import Vuex from 'vuex'
Vue.use(Vuex)


//axios
import { apiAxios } from './utils/http.js'
Vue.prototype.$http = apiAxios;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Date.prototype.format = function(fmt) {
  let o = {
    "M+" : this.getMonth()+1, //月份
    "d+" : this.getDate(), //日
    "h+" : this.getHours()%12 === 0 ? 12 : this.getHours()%12, //小时
    "H+" : this.getHours(), //小时
    "m+" : this.getMinutes(), //分
    "s+" : this.getSeconds(), //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S" : this.getMilliseconds() //毫秒
  };
  if (!fmt) {
    fmt = "yyyy-MM-dd HH:mm:ss";
  }
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(let k in o)
    if(new RegExp("("+ k +")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}
Array.prototype.remove = function(index) {
  return this.slice(0, index).concat(this.slice(index + 1, this.length));
}



// WEBPACK FOOTER //
// ./src/main.js